module.exports = __webpack_public_path__ + "static/media/mujer-hombre7.457b2f43.jpg";